import React from "react";
import DynamicDecubitusClockDrawing from "./DynamicDecubitusClockDrawing";

// Props
interface FixedDecubitusClockDrawingProps {
    size?: number;
    hasBlinkingBall?: boolean;
}

// Component
function FixedDecubitusClockDrawing({ size = 400, hasBlinkingBall = true }: FixedDecubitusClockDrawingProps) {
    // Create a mocked startMonitoringDate with the current date at 00:00:00
    // This will cause the dynamic clock to look exactly like the original one
    const startMonitoringDate = new Date();
    startMonitoringDate.setHours(0, 0, 0, 0);

    return <DynamicDecubitusClockDrawing startMonitoringDate={startMonitoringDate} allHourLabels={false} size={size} hasBlinkingBall={hasBlinkingBall} />;
}

export default FixedDecubitusClockDrawing;
